import type { FC } from 'react'
import { useSuspenseQuery } from '~/services'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@bpinternal/ui-kit-next'
import { Avatar, Link } from '~/elements'

type Props = {
  count?: number
  workspaceId: string
}

export const MembersPreview: FC<Props> = ({ count = 4, workspaceId }) => {
  const workspaceMembers = useSuspenseQuery('workspaces_/$workspaceId_/members', { workspaceId }).data

  const shownMembers = workspaceMembers.slice(0, count - 1)
  const totalHiddenCount = workspaceMembers.length - (count - 1)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center">
        <div className="flex">
          {shownMembers?.map((member) => (
            <HoverCard key={member.id}>
              <HoverCardTrigger>
                <Avatar
                  name={member.displayName ?? member.email}
                  pictureUrl={member.profilePicture}
                  className="-mr-2 box-content h-8 w-8 rounded-full align-baseline text-lg font-normal ring-2 ring-neutral-50"
                  variant="solid"
                />
              </HoverCardTrigger>
              <HoverCardContent side="top" className="w-full">
                <div className="flex gap-2">
                  <Avatar
                    name={member.displayName ?? member.email}
                    pictureUrl={member.profilePicture}
                    className="h-8 w-8 rounded-full text-lg font-normal"
                    variant="solid"
                  />
                  <div className="flex flex-col">
                    <span className="text-sm font-medium">{member.email}</span>
                    <span className="text-xs text-neutral-900">{member.role}</span>
                  </div>
                </div>
              </HoverCardContent>
            </HoverCard>
          ))}

          {totalHiddenCount > 0 && (
            <Link
              to="/workspaces/$workspaceId/settings/members"
              params={{ workspaceId }}
              className="transition-color z-[1] flex h-8 w-8 items-center justify-center rounded-full border-neutral-50 bg-neutral-100 text-xs font-medium text-neutral-900 !no-underline ring-2 ring-neutral-50 hover:bg-neutral-200"
            >
              +{totalHiddenCount}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
